<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import i18n, { LANGUAGE_LIST, type LanguageListValues } from '@/i18n';
import { useGroupStore } from '@/stores/group';
import { leaveSettings } from './leave-settings';

import SettingsHeader from './SettingsHeader.vue';
import SettingsRow from './SettingsRow.vue';

const { t } = i18n.global;
const router = useRouter();
const groupStore = useGroupStore();

const currentLocale = computed<LanguageListValues>(() => i18n.global.locale);

function selectLanguage(locale: LanguageListValues) {
  i18n.global.locale = locale;
  localStorage.setItem('locale', locale);
  leaveSettings(router, groupStore.group?.group_id);
}
</script>

<template>
  <div class="page page--no-navbar">
    <div class="content languages-page">
      <SettingsHeader :title="$t('settings.languages')" />

      <div class="languages-page__card">
        <SettingsRow
          v-for="locale in LANGUAGE_LIST"
          :key="locale"
          :label="t('lang', locale)"
          :trailing-icon="locale === currentLocale ? 'check' : undefined"
          @click="selectLanguage(locale)"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.languages-page {
  background-color: $color-neutral-lower;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  &__card {
    background-color: $color-white;
    border-radius: $radius-xl;
    display: flex;
    flex-direction: column;
    margin: $spacing-5;
    overflow: hidden;
    border: 1px solid $color-border-medium;
  }
}
</style>
